/* Suppress Judge.me's programmatic jump-to-reviews on pagination; user scrolling is never intercepted (old scroll-event snap-back trapped the user). */
(function () {
  var W = window, E = Element.prototype, H = HTMLElement.prototype;
  var topDesc = Object.getOwnPropertyDescriptor(E, 'scrollTop');
  var nTo = W.scrollTo, nScroll = W.scroll, nSIV = E.scrollIntoView, nFocus = H.focus;
  var armed = false, cap = 0, grace = 0, mo;

  function disarm() { armed = false; clearTimeout(cap); clearTimeout(grace); if (mo) mo.disconnect(); }

  function arm() {
    if (armed) return;
    armed = true;
    cap = setTimeout(disarm, 4000);                       // safety: never stay armed forever
    if (!W.MutationObserver) return;
    (mo = mo || new MutationObserver(function (recs) {     // release once new reviews land (+ grace for JM's scroll)
      for (var i = 0; i < recs.length; i++)
        for (var j = 0, a = recs[i].addedNodes; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('.jdgm-rev')) || (n.querySelector && n.querySelector('.jdgm-rev')))) {
            clearTimeout(grace); grace = setTimeout(disarm, 700); return;
          }
        }
    })).observe(document.getElementById('judgeme_product_reviews') || document.body, { childList: true, subtree: true });
  }

  // Suppress ONLY programmatic scrolls while armed.
  W.scrollTo = function () { return armed ? undefined : nTo.apply(this, arguments); };
  W.scroll   = function () { return armed ? undefined : nScroll.apply(this, arguments); };
  E.scrollIntoView = function () { return armed ? undefined : nSIV.apply(this, arguments); };
  H.focus = function () {                                  // focus() auto-scrolls; force preventScroll while armed
    if (armed) { try { return nFocus.call(this, { preventScroll: true }); } catch (e) {} }
    return nFocus.apply(this, arguments);
  };
  if (topDesc && topDesc.set) Object.defineProperty(E, 'scrollTop', {
    configurable: true,
    get: function () { return topDesc.get.call(this); },
    set: function (v) { if (!armed) topDesc.set.call(this, v); }   // block only JS writes; user scroll never calls this
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.jdgm-paginate__page')) arm();
  }, true);
})();

/* Rating summary: swap Judge.me's "4.72 out of 5" to the Figma "4.72 / 5" (widget hydrates async, so retry). */
(function () {
  function reformat() {
    var el = document.querySelector('.jdgm-rev-widg__summary-average');
    if (!el) return false;
    if (el.textContent.indexOf(' out of ') !== -1) {
      el.textContent = el.textContent.replace(' out of ', ' / ');
    }
    return true;
  }
  if (!reformat()) {
    var iv = setInterval(function () { if (reformat()) clearInterval(iv); }, 400);
    setTimeout(function () { clearInterval(iv); }, 20000);
  }
})();
